import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=175f50b2&scoped=true"
import script from "./step3.vue?vue&type=script&lang=js"
export * from "./step3.vue?vue&type=script&lang=js"
import style0 from "./step3.vue?vue&type=style&index=0&id=175f50b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f50b2",
  null
  
)

export default component.exports